import { useEffect, useState } from 'react';

const useIntersectionObserver = (
  itemEl?: Element | null,
  containerEl?: IntersectionObserverInit['root'],
  options?: IntersectionObserverInit,
) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const defaultOptions = {
      root: containerEl || null,
      rootMargin: '0px',
      threshold: 0,
    };

    const observerOptions = options ?? defaultOptions;

    const onVisible = (entries: any) => {
      const [entry] = entries;
      setIsVisible(entry.isIntersecting);
    };

    let containerObserver: IntersectionObserver;
    try {
      containerObserver = new IntersectionObserver(onVisible, observerOptions);
    } catch (e) {
      throw new Error(`[IntersectionObserver Error] ${containerEl}` + e);
    }

    if (itemEl) {
      containerObserver.observe(itemEl);
    }

    return () => {
      containerObserver.disconnect();
    };
  }, [itemEl, containerEl, options]);

  return { isVisible };
};

export default useIntersectionObserver;
